import { Link } from 'react-router-dom';
import { additionalArticles } from '@/mocks/seo-content';

export default function ArticlesGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-medium mb-4 whitespace-nowrap">
            Artigos SEO
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
            Guias e Artigos
          </h2>
          <p className="text-lg md:text-xl font-heading font-extralight text-foreground-500">
            Conteúdo exclusivo para compras inteligentes
          </p>
          <p className="text-sm md:text-base text-foreground-500 font-light mt-4 max-w-[520px] mx-auto">
            Artigos detalhados com dicas, guias e análises para maximizar a sua experiência de compras na China.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {additionalArticles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-background-300 transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  title={article.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1.5 leading-snug group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 font-light leading-relaxed mb-3">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground-600 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                  Ler artigo
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}